import { useRouter } from "next/router";
import { useRef, useEffect, useState, useCallback } from "react";
import { LOCALE_OPTIONS } from "../api/base";

const useTTS = (text: string, isTranslated: boolean) => {
  const [isPlaying, setIsPlaying] = useState<boolean | null>(false);
  const [utterance, setUtterance] = useState<SpeechSynthesisUtterance | null>(
    null
  );
  const play = useCallback(() => {
    if (isPlaying) speechSynthesis.cancel();
    setTimeout(() => {
      if (utterance && utterance.voice) {
        setIsPlaying(true);
        speechSynthesis.speak(utterance);
      }
    });
  }, [utterance, isPlaying]);
  const pause = () => {
    speechSynthesis.pause();
  };
  const resume = () => speechSynthesis.resume();
  const { locale: incLocale } = useRouter();
  const locale = (incLocale || "en") as LOCALE_OPTIONS;
  useEffect(() => {
    speechSynthesis.onvoiceschanged = (e) => {
      speechSynthesis.cancel();
      const voice = speechSynthesis
        .getVoices()
        .filter((voice) => voice.lang.startsWith(locale));
      const utter = new SpeechSynthesisUtterance(text);
      utter.addEventListener("error", console.error);
      utter.addEventListener("end", () => {
        setIsPlaying(false);
      });
      utter.addEventListener("pause", () => {
        setIsPlaying(null);
      });
      utter.addEventListener("resume", () => {
        setIsPlaying(true);
      });
      utter.addEventListener("start", () => {
        setIsPlaying(true);
      });
      if (voice)
        utter.voice =
          voice.find((v) => {
            if (locale === "en") {
              return v.lang === "en-US" && v.localService;
            } else if (locale === "pt") {
              return v.lang === "pt-BR" && v.localService;
            }
          }) || voice[0];
      setUtterance(utter);
    };
    return () => {
      speechSynthesis.onvoiceschanged = null;
      speechSynthesis.cancel();
    };
  }, [locale]);
  return { play, pause, resume, utterance, isPlaying };
};

export { useTTS };
